import "./page-harvesting-hope-standing-with-ukraine.scss";
import Modal from "bootstrap/js/src/modal";
import { Chart, registerables } from "chart.js";
// import "sticky-kit/dist/sticky-kit";

let occupiedRegion, region;
let clickedElement,
  modalContent,
  myChart = null;
let jsonData;
const currentLang = $("html").attr("lang");

async function requestToJSON(url) {
  try {
    // Отправляем запрос к указанному URL
    let responce = await fetch(url);

    // Преобразуем ответ в JSON
    let getObject = await responce.json();

    // Выводим полученный объект в консоль
    return getObject;
  } catch (error) {
    // В случае ошибки выводим её в консоль
    console.error("JSON error:", error);
  }
}

$("[data-region]").on("click", function () {
  clickedElement = $(this);

  $("#exampleModal").modal("show");
});

$("#exampleModal").on("show.bs.modal", async function (event) {
  let regionTrigger;

  if (!jsonData) {
    jsonData = await requestToJSON(
      window.location.origin +
        "/wp-content/docs/harvesting-hope-standing-with-ukraine/region.json"
    );
  }

  if (jsonData && jsonData[clickedElement.data("region")]) {
    regionTrigger = clickedElement.data("region");
    let imgBox = $(this).find(".img-wrap");
    let imgBoxPath = imgBox.data("src");

    if (currentLang === "uk") {
      $(this).find(".title").text(jsonData[regionTrigger]["title-ukr"]);
    } else {
      $(this).find(".title").text(jsonData[regionTrigger].title);
    }

    if (jsonData[regionTrigger].img !== undefined) {
      imgBox.append(
        "<img src='" + imgBoxPath + jsonData[regionTrigger].img + "'/>"
      );
    }

    let typeDataInfo = $(".map-wrap").attr("data-active-type");
    $(this).addClass(typeDataInfo);

    if (clickedElement) {
      if (clickedElement.hasClass("occupied") === true) {
        $(this).addClass("has-occupied");
      } else {
        if (clickedElement.hasClass("mid-occupied") === true) {
          $("#exampleModal").addClass("mid-occupied");
        }

        // Регистрируем компоненты, включая Legend
        Chart.register(...registerables);
        Chart.defaults.font.size = 14;
        Chart.defaults.font.weight = 600;
        Chart.defaults.font.family = "IBM Plex Sans, sans-serif";
        Chart.defaults.elements.point.radius = 6;
        Chart.defaults.elements.point.hoverRadius = 8;
        let legendMargin = {
          id: "legendMargin",
          beforeInit(chart, legend, options) {
            let fitValue = chart.legend.fit;
            chart.legend.fit = function fit() {
              fitValue.bind(chart.legend)();
              return (this.height += 40);
            };
          },
        };

        const dash = (ctx, value) => (ctx.p0DataIndex < 2 ? value : [4, 8]);

        let data = {
          // Ваши данные

          labels: [2021, 2022, 2023, 2024],
          datasets: [
            {
              label: currentLang === "uk" ? "Озима пшениця" : "Winter wheat",
              data:
                jsonData[regionTrigger].type[typeDataInfo]["winter-wheat"] !==
                undefined
                  ? jsonData[regionTrigger].type[typeDataInfo]["winter-wheat"]
                  : [0, 0, 0, 0],
              backgroundColor: "#4F8BE5",
              borderColor: "#4F8BE5",
              noActiveColor: "rgba(79, 139, 229, 0.5)",
              segment: {
                borderDash: (ctx) => dash(ctx),
              },
            },
            {
              label: currentLang === "uk" ? "Ярий Ячмінь" : "Barley",
              data:
                jsonData[regionTrigger].type[typeDataInfo]["barley"] !==
                undefined
                  ? jsonData[regionTrigger].type[typeDataInfo]["barley"]
                  : [0, 0, 0, 0],
              backgroundColor: "#E5A04F",
              borderColor: "#E5A04F",
              noActiveColor: "rgba(229, 160, 79, 0.5)",
              segment: {
                borderDash: (ctx) => dash(ctx),
              },
            },
            {
              label: currentLang === "uk" ? "Кукурудза" : "Corn",
              data:
                jsonData[regionTrigger].type[typeDataInfo]["corn"] !== undefined
                  ? jsonData[regionTrigger].type[typeDataInfo]["corn"]
                  : [0, 0, 0, 0],
              backgroundColor: "#D9E54F",
              borderColor: "#D9E54F",
              noActiveColor: "rgba(217, 229, 79, 0.5)",
              segment: {
                borderDash: (ctx) => dash(ctx),
              },
            },
            {
              label: currentLang === "uk" ? "Соняшник" : "Sunflower",
              data:
                jsonData[regionTrigger].type[typeDataInfo]["sunflower"] !==
                undefined
                  ? jsonData[regionTrigger].type[typeDataInfo]["sunflower"]
                  : [0, 0, 0, 0],
              backgroundColor: "#D0D2B5",
              borderColor: "#D0D2B5",
              noActiveColor: "rgba(208, 210, 181, 0.5)",
              segment: {
                borderDash: (ctx) => dash(ctx),
              },
            },
            {
              label: currentLang === "uk" ? "Соя" : "Soybean",
              data:
                jsonData[regionTrigger].type[typeDataInfo]["soybeans"] !==
                undefined
                  ? jsonData[regionTrigger].type[typeDataInfo]["soybeans"]
                  : [0, 0, 0, 0],
              backgroundColor: "#89BC71",
              borderColor: "#89BC71",
              noActiveColor: "rgba(137, 188, 113, 0.5)",
              segment: {
                borderDash: (ctx) => dash(ctx),
              },
            },
          ],
        };

        let config = {
          type: "line", // Тип графика
          data,
          options: {
            tension: 0.2,
            maintainAspectRatio: false,
            scales: {
              x: {
                grid: {
                  drawBorder: false,
                  color: "transparent", // Скрытие вертикальных линий
                },
                ticks: {
                  // Настройки меток
                  color: "#ffffff",
                  font: {
                    size: 16,
                  },
                },
              },
              y: {
                // min: 0,
                // max: 100,
                // beginAtZero: true,

                grid: {
                  drawBorder: false,
                  drawTicks: false,

                  color: "#4A5A6A",
                  borderDash: [2, 6], // Стиль линии: точки
                },
                ticks: {
                  color: "#8296AA",
                  // stepSize: 525 / 4, // Отступ между линиями

                  callback: function (value, index, ticks) {
                    return value + "       ";
                  },
                },
              },
            },
            plugins: {
              legend: {
                position: "top", // Выравнивание легенды
                align: "start", // Выравнивание текста в легенде
                onClick: (event, legendItem, legend) => {
                  let datasets = legend.legendItems.map((dataset, index) => {
                    return dataset.text;
                  });

                  let index = datasets.indexOf(legendItem.text);

                  if (legend.chart.isDatasetVisible(index) === true) {
                    legend.chart.hide(index);
                  } else {
                    legend.chart.show(index);
                  }
                },
                onHover: (event, chartElement) => {
                  event.native.target.style.cursor = "pointer";
                },
                onLeave: (event, chartElement) => {
                  event.native.target.style.cursor = "default";
                },
                labels: {
                  usePointStyle: true,
                  boxWidth: 4,
                  boxHeight: 4,
                  padding: 6,
                  generateLabels: (chart) => {
                    let visibility = [];
                    for (let i = 0; i < chart.data.datasets.length; i++) {
                      if (chart.isDatasetVisible(i) === false) {
                        visibility.push(true);
                      } else {
                        visibility.push(false);
                      }
                    }

                    return chart.data.datasets.map((dataset, index) => ({
                      text: dataset.label + "  ",
                      fillStyle: !visibility[index]
                        ? dataset.backgroundColor
                        : dataset.noActiveColor,
                      strokeStyle: !visibility[index]
                        ? dataset.borderColor
                        : dataset.noActiveColor,
                      fontColor: !visibility[index]
                        ? dataset.borderColor
                        : dataset.noActiveColor,
                      // hidden: visibility[index],
                    }));
                  },
                },
              },
            },
          },
          plugins: [legendMargin],
        };

        myChart = new Chart(document.getElementById("myChart"), config);
      }
    }
  }
});

$("#exampleModal").on("hidden.bs.modal", function () {
  if (myChart && typeof myChart.destroy === "function") {
    myChart.destroy(); // Уничтожаем график
    myChart = null; // Обнуляем переменную
    modalContent = null;
    // $(this).find(".modal-body").empty();
  }

  $(this).find(".img-wrap").empty();

  $(this).removeClass("has-occupied SownArea Yield Production mid-occupied");
});

document.addEventListener("visibilitychange", function () {
  if (document.visibilityState === "visible" && myChart !== null) {
    // Код для обновления или пересоздания графика
    myChart.update();
  }
});

import(
  /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
).then(() => {
  import(
    /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
  ).then(() => {
    $(".slider-card-blog").owlCarousel({
      responsive: {
        0: {
          items: 1,
        },
        620: {
          items: 2,
        },
        992: {
          items: 3,
        },
      },
      loop: false,
      nav: true,
      dots: false,
      slideBy: 1,
      margin: 20,
      smartSpeed: 200,
    });

    $(".slider-countries").owlCarousel({
      items: 1,
      loop: false,
      nav: true,
      dots: false,
      slideBy: 1,
      margin: 20,
      smartSpeed: 200,
    });

    $(".world-map .btn-country").on("click", function () {
      let slideIndex = $(this).data("slide");
      $(".slider-countries").trigger("to.owl.carousel", [slideIndex, 100]);
    });

    $(".slider-countries").on("changed.owl.carousel", function (event) {
      let index = event.item.index;
      $(".world-map .btn-country").removeClass("active");
      $('.world-map .btn-country[data-slide="' + index + '"]').addClass(
        "active"
      );
    });

    $(".owl-carousel").each(function (index) {
      $(this)
        .find(".owl-nav, .owl-dots")
        .wrapAll("<div class='owl-controls'></div>");
    });
  });
});

(function anchorScroll() {
  var scrollIterationsCounter = 0;

  $(window).on("load", function () {
    var hash = window.location.hash;
    let shortHash = hash.substring(1);
    let isAnchorScroll = $("body").find(`[data-anchor='${shortHash}']`);
    if ($(hash).length && isAnchorScroll.length) {
      scrollToDiv($(hash));
      isAnchorScroll.addClass("active");
    } else {
      $(".dropdown .nav li:first-child a").addClass("active");
    }
    let activeText = $(".js-scroll-nav.active")
      .clone()
      .children("span")
      .remove()
      .end()
      .text();
    $(".dropdown .value").text(activeText);
  });

  $(".js-scroll-nav").on("click", function (event) {
    event.preventDefault();
    var el = $(this).attr("data-anchor");

    var elWrapped = $("#" + el);
    if ($(elWrapped).length) {
      scrollToDiv(elWrapped);
      history.pushState({}, "", "#" + el);
    }

    $(".js-scroll-nav").removeClass("active");
    $(this).addClass("active");
    let activeText = $(".js-scroll-nav.active")
      .clone()
      .children("span")
      .remove()
      .end()
      .text();
    $(".dropdown .value").text(activeText);
  });

  function scrollToDiv(element) {
    if (element) {
      var navHeight = 20;

      var offset = element.offset();
      var offsetTop = offset.top;
      var totalScroll = Math.round(offsetTop - navHeight);
      scrollIterationsCounter++;

      $("body,html").animate(
        {
          scrollTop: totalScroll,
        },
        500,
        function () {
          if (
            !checkScrollPosition(element) &&
            scrollIterationsCounter < 4 &&
            !isAnchorOnTheBottom(element)
          ) {
            scrollToDiv(element);
          } else {
            scrollIterationsCounter = 0;
          }
        }
      );
    }
  }

  function checkScrollPosition(element) {
    if (element) {
      var navHeight = 20;

      var offset = element.offset();
      var offsetTop = offset.top;
      var totalScroll = Math.round(offsetTop - navHeight);
      var pageScrollPosition = Math.round($(window).scrollTop());
      if (Math.abs(pageScrollPosition - totalScroll) > 30) {
        return false;
      } else {
        return true;
      }
    }
  }

  function isAnchorOnTheBottom(element) {
    if (element) {
      var offset = element.offset();
      var offsetTop = offset.top;
      var windowHeight = $(window).height();
      var documentHeight = $(document).height();
      var elementBottomOffset = documentHeight - offsetTop;
      if (windowHeight > elementBottomOffset) {
        return true;
      } else {
        return false;
      }
    }
  }
})();

(function StickyRow() {
  let scroll = $(window).scrollTop();
  let windowHeight = $(window).height();
  let contentHeight = $(".section-global-scale .content-wrap").height();
  let row1 = $(".section-global-scale .row-1");
  let row2 = $(".section-global-scale .row-2");
  let row3 = $(".section-global-scale .row-3");
  let startContent = $(".section-global-scale .content-wrap").offset().top;

  function changeActiveRow(windowHeight, contentHeight, startContent, scroll) {
    if (scroll < startContent + contentHeight / 3 - windowHeight / 3) {
      row1.addClass("active");
      row2.removeClass("active");
      row3.removeClass("active");
    } else if (
      scroll > startContent + contentHeight / 3 - windowHeight / 3 &&
      scroll < startContent + (contentHeight / 3 - windowHeight / 3) * 2
    ) {
      row1.removeClass("active");
      row2.addClass("active");
      row3.removeClass("active");
    } else if (
      scroll >
      startContent + (contentHeight / 3 - windowHeight / 3) * 2
    ) {
      row1.removeClass("active");
      row2.removeClass("active");
      row3.addClass("active");
    }
  }

  changeActiveRow(windowHeight, contentHeight, startContent, scroll);

  $(window).resize(function () {
    windowHeight = $(window).height();
    contentHeight = $(".section-global-scale .content-wrap").height();
    scroll = $(window).scrollTop();
    startContent = $(".section-global-scale .content-wrap").offset().top;
    changeActiveRow(windowHeight, contentHeight, startContent, scroll);
  });

  $(window).scroll(function () {
    scroll = $(window).scrollTop();
    changeActiveRow(windowHeight, contentHeight, startContent, scroll);
  });
})();

function headerScrolled() {
  var scroll = $(window).scrollTop();
  if (scroll > 0) {
    $("body").addClass("scrolled");
  } else {
    $("body").removeClass("scrolled");
  }
}

$(document).ready(function () {
  $('input[name="mapType"]').change(function () {
    var selectedValue = $(this).val();
    $(".map-wrap").attr("data-active-type", selectedValue);
  });

  $(".select-region .fake-input").on("click", function () {
    $(this).parent(".select-region").toggleClass("active");
  });
  $(".select-region li").on("click", function () {
    let getValue = $(this).text();
    $(".select-region .value").text(getValue);
    $(this)
      .parents(".select-region")
      .removeClass("active")
      .addClass("selected");
  });

  $(".js-scroll-nav").on("click", function () {
    $("#exampleModal").modal("hide");
  });
});

headerScrolled();

$(window).scroll(function () {
  headerScrolled();
});
